import React, { memo } from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';

import { HeaderTitle, Icon } from '@atlas/ui';

import HeaderLogoItem from 'components/Layout/Header/HeaderLogoItem';

const SignUpHeader = ({ onClose, signUpPopup = 'registration' }) => {
  return (
    <HeaderTitle className={cx('center block-lg border')}>
      {signUpPopup && (
        <>
          <HeaderLogoItem logoPosition="center" />
          <div className="header-title__children">
            <div
              onClick={onClose}
              onKeyDown={e => {
                if (e.key === 'Enter' || e.key === ' ') {
                  e.preventDefault();
                  onClose();
                }
              }}
              role="button"
              tabIndex={0}
            >
              <Icon name="close" />
            </div>
          </div>
        </>
      )}
    </HeaderTitle>
  );
};

SignUpHeader.propTypes = {
  onClose: PropTypes.func,
  signUpPopup: PropTypes.bool,
  title: PropTypes.string,
};

export default memo(SignUpHeader);
